import React, {
  createContext,
  useContext,
  useReducer,
  useRef,
  ReactNode,
} from "react";
import { betSlipReducer } from "../reducers";
import { getInitialWidgetState } from "../shared/utils/action-state";

const WidgetContext = createContext<WidgetContextState | undefined>(undefined);

interface WidgetContextState extends IWidgetState {
  dispatch: React.Dispatch<any>;
  placeBetInProgressRef: React.MutableRefObject<boolean>;
}

interface WidgetProviderProps extends IWidgetState {
  children: ReactNode;
}

export const WidgetProvider: React.FC<WidgetProviderProps> = ({
  children,
  config,
  betSlipState,
  id,
}) => {
  const [state, dispatch] = useReducer(
    betSlipReducer,
    getInitialWidgetState({
      config,
      id,
      betSlipState,
    }),
  );

  const placeBetInProgressRef = useRef(false);

  const contextValue: WidgetContextState = {
    dispatch,
    config: state.config,
    betSlipState: state.betSlipState,
    id: state.id,
    error: state.error,
    placeBetInProgressRef,
  };

  return (
    <WidgetContext.Provider value={contextValue}>
      {children}
    </WidgetContext.Provider>
  );
};

export const useWidgetContext = (): WidgetContextState => {
  const context = useContext(WidgetContext);
  if (!context) {
    throw new Error("useWidgetContext must be used within a WidgetProvider");
  }
  return context;
};
